import { AuditRequest } from 'types';
import { GetAuditRequestsResponse } from 'api';
import { addDays } from 'date-fns';

const mockHttpCodes = [200, 401, 404, 500];

const getRandomCode = (): number => {
  return mockHttpCodes[Math.floor(Math.random() * 3)];
};

const formattedJsonString = JSON.stringify(
  {
    msg: {
      id: 999,
      fact1: 'fact 1 details',
      fact2: 'fact 2 details',
      fact3: 'fact 3 details',
      fact4: 'fact 4 details',
      fact5: 'fact 5 details',
      fact6: 'fact 6 details',
      fact7: 'fact 7 details',
      fact8: 'fact 8 details',
      fact9: 'fact 9 details',
      fact10: 'fact 10 details',
      fact11: 'fact 11 details',
      fact12: 'fact 12 details',
      fact13: 'fact 13 details',
      fact14: 'fact 14 details',
      fact15: 'fact 15 details',
      fact16: 'fact 16 details',
      fact17: 'fact 17 details',
      fact18: 'fact 18 details',
      fact19: 'fact 19 details',
    },
  },
  null,
  2
);

export const MOCK_SINGLE_REQUEST: AuditRequest = {
  id: 999,
  date: new Date(),
  httpCode: 200,
  status: 'Success',
  direction: 'Inbound',
  apiCall: '/call/test-data',
  apiUrl: '/call/test-data?query1=20',
  detail: formattedJsonString,
  responseJson: formattedJsonString,
  planningApplicationReferenceNo: '',
};

const MOCK_TRAFFIC_DATA: AuditRequest[] = new Array(10)
  .slice(1)
  .fill(undefined)
  .map((_item, i: number) => {
    const returnHttpCode = getRandomCode();
    return {
      id: i,
      date: addDays(new Date(), 0 - i),
      httpCode: returnHttpCode,
      status: returnHttpCode < 300 ? 'Success' : 'Fail',
      direction: i % 2 === 0 ? 'Inbound' : 'Outbound',
      apiCall: '/call/' + i,
      planningApplicationReferenceNo: 'PA/2020/' + i,
      detail: JSON.stringify(
        {
          msg: {
            id: i,
            fact1: 'fact 1 details',
            fact2: 'fact 2 details',
            fact3: 'fact 3 details',
            fact4: 'fact 4 details',
            fact5: 'fact 5 details',
            fact6: 'fact 6 details',
            fact7: 'fact 7 details',
            fact8: 'fact 8 details',
            fact9: 'fact 9 details',
            fact10: 'fact 10 details',
            fact11: 'fact 11 details',
            fact12: 'fact 12 details',
            fact13: 'fact 13 details',
            fact14: 'fact 14 details',
            fact15: 'fact 15 details',
            fact16: 'fact 16 details',
            fact17: 'fact 17 details',
            fact18: 'fact 18 details',
            fact19: 'fact 19 details',
          },
        },
        null,
        2
      ),
    } as AuditRequest;
  });

const paginationInfo = {
  currentPage: 1,
  pageSize: 10,
  totalCount: 14,
  totalPages: 2,
};

export const MOCK_AUDIT_REQUEST_RESPONSE: GetAuditRequestsResponse = {
  paginationInfo,
  auditRequests: {
    items: MOCK_TRAFFIC_DATA,
  },
};

export const MOCK_AUDIT_SEARCH_REQUEST_RESPONSE: GetAuditRequestsResponse = {
  paginationInfo,
  auditRequests: {
    items: MOCK_TRAFFIC_DATA.slice(1, 1),
  },
};
